class customVariantType extends HTMLElement {
  constructor () {
    super();
    this.form = this.closest('form');
    this.badges = this.querySelectorAll('.custom-variant-type-discounted-badge');
  }

  disconnectedCallback () {
    if(this.form) {
      this.form.remoeEventListener('change', this.changeHandle.bind(this))
    }
  }

  changeHandle() {
    const variantID = this.form.querySelector('[name=id]')?.value;
    this.badges.forEach((item)=>{
      const currentID = item.getAttribute('data-variant-id');
      if(currentID === variantID) {
        item.style.display = 'block';
      }else{
        item.style.display = 'none';
      }
    });
  }
  connectedCallback () {
    if(this.form) {
      this.form.addEventListener('change', this.changeHandle.bind(this))
    }
  }
}

customElements.define('custom-variant-type', customVariantType);